<template>
	<div>

		<div v-if="picking">
			Picking ...
		</div>
		<div v-else-if="loading">
			Loading ...
		</div>
		<div v-else>
			<div class="input-row small-margin-bottom" v-if="data.message">
				<div class="label">
					Message
				</div>
				<div>
					{{ data.message }}
				</div>
			</div>

			<div v-if="!data.allow_pick" class="error">
				This order cannot be picked due to the error mentioned above
			</div>

			<div class="margin-top margin-bottom" v-if="data.require_comment && data.allow_pick">
				<div>
					Please describe why you want to pick this order:
				</div>
				<textarea cols="50" rows="4" v-model="comment"></textarea>
			</div>

			<div class="margin-top">
				<button
					v-on:click="pick"
					:disabled="picking || !data.allow_pick || (data.require_comment && !comment)">
						Pick
				</button>
				<button :disabled="picking" class="gray small-margin-left" v-on:click="$emit('close')">Cancel</button>
			</div>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    picking: false,
    data: {},
    comment: ''
  }),
  methods: {
    picked (data) {
      console.log('picked', data)
      const { id, key } = data

      this.$router.push({
        path: '/stylings/process',
        query: { id, key }
      })
    },
    pick () {
      Vue.$api.post(
        '/order/' + this.id + '/pick',
        {
          comment: this.comment
        },
        {
          loader: toggle => this.picking = toggle,
          callback: data => this.picked(data)
        }
      )
    },
    load () {
      Vue.$api.get(
        '/order/' + this.id + '/pick/preconditions',
        {},
        {
          loader: toggle => this.loading = toggle,
          callback: data => this.parse(data)
        }
      )
    },
    parse (data) {
      this.data = data

      if (data.instant) {
        this.pick()
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
